/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Mem_S2Inputs */

const en_mk_tut_mem_s2 = /** @type {(inputs: Mk_Tut_Mem_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a category — tone of voice, forbidden words, product prices, internal process, or a decision — then write the rule in one short sentence.`)
};

const id_mk_tut_mem_s2 = /** @type {(inputs: Mk_Tut_Mem_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih kategorinya — nada bicara, kata terlarang, harga produk, proses internal, atau keputusan — lalu tulis aturannya dalam satu kalimat pendek.`)
};

/**
* | output |
* | --- |
* | "Pick a category — tone of voice, forbidden words, product prices, internal process, or a decision — then write the rule in one short sentence." |
*
* @param {Mk_Tut_Mem_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_mem_s2 = /** @type {((inputs?: Mk_Tut_Mem_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Mem_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_mem_s2(inputs)
	return en_mk_tut_mem_s2(inputs)
});